{
  "flash": {
    "listing_closed": "Listing closed successfully.",

    "application_sent": "Application sent.",
    "application_rejected": "Application rejected.",
    "application_cancelled": "Application cancelled.",
    "application_ready_to_accept": "Application ready to accept.",
    "application_accepted": "Application accepted.",

    "invitation_error": "An error occurred sending the invitation. Please try again.",
    "invitation_sent": "Invitation sent.",
    "invitation_rejected": "Invitation rejected.",
    "invitation_accepted": "Invitation accepted.",
    "invitation_cancelled": "Invitation cancelled.",
    "invitation_ready_to_accept": "Invitation ready to accept."
  },
  "new": {
    "title": "New Relief Listing"
  },
  "index": {
    "title": "Relief Listings",
    "empty_list_title": "No Relief Listings",
    "empty_list_description": "Click the create button to create your first relief listing.",
    "create": "Create Relief Listing",
    "subject": "Subject",
    "start_date": "Start Date",
    "end_date": "End Date",
    "actions": {
      "close": "Close Listing",
      "close_description": "This will close all pending invitations. This action cannot be undone.",
      "requests": "Requests",
      "view_listing": "View Listing"
    }
  },
  "form": {
    "sections": {
      "details": "Details",
      "general_information": "General Information",
      "location": "Location",
      "timetable": "Timetable",
      "tags": "Tags"
    },

    "general_information_section": {
      "title": "Title",
      "description": "Description",
      "subject": "Subject",
      "curriculum": "Curriculum",
      "invite_only": "Privacy Level",
      "starts_date": "Start Date",
      "end_date": "End Date",
      "contact_email": "Contact Email",
      "contact_name": "Contact Name"
    },
    "location_section": {
      "delivery": "Delivery",
      "address": "Address"
    },
    "timetable_section": {
      "timezone": "Timezone",
      "week": "Week",
      "sessions": "Timetable Session {{index}}",
      "sessions_add_label": "Add Session",
      "sessions_remove_label": "Remove Session",
      "day": "Day",
      "start_time": "Start Time",
      "end_time": "End Time"
    },
    "tags_section": {
      "section_description": "Add tags to your listing to make it easier for the most relevant teachers to discover it."
    }
  },
  "delivery_modes": {
    "online": "Online",
    "in_person": "In Person"
  },
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "weeks": {
    "week_one": "Week One",
    "week_two": "Week Two"
  },
  "privacy_levels": {
    "invite_only": "Invite Only",
    "invite_only_description": "Teachers cannot apply to this listing. You must invite teachers.",
    "anyone_can_apply": "Anyone Can Apply",
    "anyone_can_apply_description": "Teachers can apply to this listing."
  },
  "state": {
    "open": "Open",
    "closed": "Closed",
    "accepted": "Accepted"
  },

  "applications": {
    "form": {
      "message": "Message",
      "message_pro_forma": "I'm interested in discussing the relief teaching position.\nI look forward to connecting with you.",
      "listing_profile": "Listing Profile",
      "disabled_listing": "An invitation or application already exists for this listing profile."
    },
    "send": "Apply",
    "title": "Application to {{title}} at {{school_name}}",
    "new": {
      "description": "Apply to be considered to teach."
    },
    "edit": {
      "title": "Application to {{relief_listing_title}} from {{school_name}}",
      "status_description": {
        "ready_to_accept": "You've applied to cover {{relief_listing_title}} at {{school_name}}. Accept or cancel below, or respond to the email to discuss.",
        "consideration": "You've applied to cover {{relief_listing_title}} at {{school_name}}. You must await a decision from the school or cancel your application below.",
        "accepted": "This application to {{relief_listing_title}} has been accepted",
        "cancelled": "This application to {{relief_listing_title}} has been cancelled",
        "rejected": "This application to {{relief_listing_title}} has been rejected"
      },
      "warning": "This decision is permanent and cannot be undone.",
      "accept": "Accept",
      "cancel": "Cancel",
      "accept_info": {
        "heading": "Accept Application",
        "description": "You agree to teach the class at the agreed upon time and dates with the school."
      },
      "cancel_info": {
        "heading": "Cancel Application",
        "description": "Cancel your application to teach the class. This action cannot be undone and you cannot apply again."
      }
    }
  },

  "requests": {
    "types": {
      "invitation": "Invitation",
      "application": "Application"
    },
    "status": {
      "ready_to_accept": "Pending Acceptance",
      "consideration": "Under Consideration",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "index": {
      "title": "Requests",
      "empty_list_title": "No Requests",
      "empty_list_description": "There are no requests for this listing. Use the invite button below to start inviting educators to this listing.",
      "invite": "Invite Educators",
      "view_listing": "View Listing",
      "actions": {
        "cancel_description": "By cancelling this invitation the educator cannot apply or be invited again. This action cannot be undone.",
        "cancel": "Cancel Invitation",
        "reject_description": "By rejecting this application the educator cannot apply again. This action cannot be undone.",
        "reject": "Reject Application",
        "allow_acceptance_description": "A email will be sent to the educator so they can accept the {{type}}. Continue?",
        "allow_acceptance": "Allow Acceptance"
      }
    }
  },

  "invitations": {
    "form": {
      "message": "Message",
      "message_pro_forma": "We’re interested in discussing an open relief teaching position.\nWe look forward to connecting with you.",
      "listing": "Listing",
      "disabled_listing": "An invitation or application already exists for this listing profile."
    },
    "send": "Send Invitation",
    "new": {
      "title": "Invite {{name}}",
      "description": "Start the conversation about filling your open relief teaching role."
    },
    "responses": {
      "new": {
        "title": "Invitation from {{school_name}} for {{relief_listing_title}}",
        "status_description": {
          "ready_to_accept": "You've been invited to cover {{relief_listing_title}} at {{school_name}}. Accept or decline below, or respond to the invitation email to discuss.",
          "consideration": "You've been invited to cover {{relief_listing_title}} at {{school_name}}. Reply to the invitation email to discuss next steps.",
          "accepted": "This invitation to {{relief_listing_title}} has been accepted",
          "rejected": "This invitation to {{relief_listing_title}} has been rejected",
          "cancelled": "this invitation to {{relief_listing_title}} has been cancelled"
        },
        "warning": "This decision is permanent and cannot be undone.",
        "accept": "Accept",
        "reject": "Reject",
        "accept_info": {
          "heading": "Accept invitation",
          "description": "You agree to teach the class at the agreed upon time and dates with the school."
        },
        "reject_info": {
          "heading": "Reject invitation",
          "description": "You won't teach the class. This action cannot be undone."
        }
      }
    }
  }
}
